import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

export const ButtonIcon = styled(ButtonPlain).attrs({
	tabIndex: -1,
})`
	background-color: transparent;
	border-radius: 0;
	min-width: 36px;
	padding: 0 8px;
	color: ${({ theme }) => theme.color.input.textHint};
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: auto;
	transition: background-color 135ms ease, color 135ms ease;

	&:disabled {
		color: ${({ theme }) => theme.color.input.disabled};
	}

	&:hover:enabled,
	&:focus:enabled {
		color: ${({ theme }) => theme.color.input.focus};
		background-color: ${({ theme }) => transparentize(0.6, theme.color.input.focus)};
	}
`
